// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import { Classes } from "src/mpd-library";

import { GeoMap } from "src/controllers/alerts/components";

import "./styles.css";

export interface IAlertSummaryProps extends HTMLDivProps {
  previewSend: any;
}

export const AlertSummary: React.SFC<IAlertSummaryProps> = props => {
  const { className, previewSend } = props;

  const classes = classNames(
    "alert-summary",
    myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER,
    className
  );
  return (
    <div className={classes}>
      <Text className="header"> Alert Summary </Text>
      <div className="item-container">
        <div className="item-headers-container">
          <Text className="item-header"> Audience: </Text>
          <Text className={classNames("item-header", "geoFence")}>
            Geo-Fence:
          </Text>
          <Text className="item-header"> Starting: </Text>
          <Text className="item-header"> Ending: </Text>
          <Text className="item-header"> Severity: </Text>
          <Text className="item-header"> Channels: </Text>
        </div>
        <div className="item-info-container">
          <Text className="item-info"> {previewSend.audience} </Text>
          <div
            className={classNames(
              "item-info",
              "geo-fence-map-container",
              previewSend.geoFence.currentShape && Classes.ACTIVE
            )}
          >
            {previewSend.geoFence.currentShape && (
              <GeoMap
                style={{
                  height: `100%`,
                  borderRadius: "20px",
                  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
                }}
                hideControls={true}
                zoom={13}
                center={previewSend.geoFence.currentShape.center}
                currentShape={previewSend.geoFence.currentShape}
              />
            )}
          </div>
          <Text className="item-info"> Immediately </Text>
          <Text className="item-info"> {previewSend.expiration} </Text>
          <Text className="item-info"> {previewSend.severity} </Text>
          <div className="item-inner-container">
            {previewSend.channels.map((channel: string, index: number) => (
              <Text className="item-info" key={index}> {channel} </Text>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/preview-send/alert-summary.tsx